import { cn } from "utils/helpers";
import { DashboardRfxItemData } from "../types/DashboardRfxItemData";
import { Text, GridItem, Grid } from "@chakra-ui/react";

export const DashboardProgressBar: React.FC<{
	item: DashboardRfxItemData;
}> = ({ item }) => {
	const { statusCounts, hasReachedDeadline } = item;

	const calculateProgress = (): number => {
		if (hasReachedDeadline) {
			return 4;
		}

		if (statusCounts.submitted > 0) {
			return 4;
		} else if (statusCounts.responsesInProgress > 0) {
			return 3;
		} else if (statusCounts.accepted > 0) {
			return 2;
		} else if (statusCounts.invitationsSent > 0) {
			return 1;
		}

		return 0;
	};

	const getBorderClasses = (id: number): string => {
		const progress = calculateProgress();

		if (progress === 0 || id > progress) {
			return "";
		}

		const backColor: string = "bg-blue-200";
		let classes: string;

		if (id === 1) {
			classes = `rounded-l-lg`;
		}

		if (id === progress) {
			return cn(classes, "rounded-r-lg", backColor);
		} else {
			return cn(classes, backColor);
		}
	};

	return (
		<>
			{item.hasReachedDeadline && (
				<Text className="text-sm text-red-500">Deadline Reached</Text>
			)}
			<Grid templateColumns="1fr auto">
				<GridItem>
					<Grid
						className="mb-0 rounded-lg border bg-blue-50 p-0 text-center"
						templateColumns="repeat(4, 1fr)"
						gap="0"
					>
						<GridItem
							colSpan={1}
							className={getBorderClasses(1)}
						>
							<Text className="text-black-600 text-sm font-bold">
								{statusCounts.invitationsSent}
							</Text>
						</GridItem>
						<GridItem
							colSpan={1}
							className={getBorderClasses(2)}
						>
							<Text className="text-black-600 text-sm font-bold">
								{statusCounts.accepted +
									statusCounts.responsesInProgress +
									statusCounts.submitted}
							</Text>
						</GridItem>
						<GridItem
							colSpan={1}
							className={getBorderClasses(3)}
						>
							<Text className="text-black-600 text-sm font-bold">
								{statusCounts.responsesInProgress}
							</Text>
						</GridItem>
						<GridItem
							colSpan={1}
							className={getBorderClasses(4)}
						>
							<Text className="text-black-600 text-sm font-bold">
								{statusCounts.submitted}
							</Text>
						</GridItem>
					</Grid>
					<Grid
						className="text-center"
						templateColumns="repeat(4, 1fr)"
						gap="0"
					>
						<GridItem colSpan={1}>
							<Text className="text-xs text-blue-600">Invitations Sent</Text>
						</GridItem>
						<GridItem colSpan={1}>
							<Text className="text-xs text-blue-600">Accepted</Text>
						</GridItem>
						<GridItem colSpan={1}>
							<Text className="text-xs text-orange-600">In Progress</Text>
						</GridItem>
						<GridItem colSpan={1}>
							<Text className="text-xs text-green-600">Submitted</Text>
						</GridItem>
					</Grid>
				</GridItem>
				{/* <GridItem colSpan={1}>
				{status === "deadline_reached" && <Text className="text-xs text-red-600">Deadline Reached</Text>}
			</GridItem> */}
			</Grid>
		</>
	);
};
